/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import moment from "moment-jalaali";
import { toAbsoluteUrl } from "../../../../../../../_themeBase/_helpers";



export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditObjectPage,
    haveEditAction,
    openDeleteObjectDialog,
    openRefreshObjectDialog,
    haveDeleteAction,
    openConfirmObjectPage,
    confirmAction,
    openPaymentDialog,
    openFreePaymentDialog,
    payAction,
    attendanceShiftAction,
    openShiftAttendancePage,
    transactionAction,
    openTransactionPage,
    cancelManagerAction,
    cancelStudentAction,
    sportCancelAction,
    openSportReservCancelDialog,
    openCancelDialog,
    replaceReservationAction,
    openReplaceReservationPage,
    haveRefrenceButton,
    openRefrencePage,
    openChangeStatusPage,
    openCorrespondenceHistoryPage,
    showUserInfo,
    openUserPage,
    haveEditCreditAction,
    openEditCreditActionPage,
    haveCreateCopyAction,
    openCreateCopyPage,
    manualSwapAction,
    openManualSwapDialog
  }
) => (
  <>

    {haveEditCreditAction && <OverlayTrigger
      overlay={<Tooltip id="objects-editCredit-tooltip">افزایش اعتبار </Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm "
        onClick={() => openEditCreditActionPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Wallet3.svg")} />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>


    {transactionAction && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">تراکنش ها </Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm "
        onClick={() => openTransactionPage(row.idNumber)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Sale1.svg")} />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>

    {attendanceShiftAction && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">شیفت کاری : {row.shiftCategoryTitle}</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-success btn-sm "
        onClick={() => openShiftAttendancePage(row.idNumber)}
      >
        <span className="svg-icon svg-icon-md svg-icon-success">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")} />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>
    {haveRefrenceButton && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip"> تاریخچه</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm "
        onClick={() => openCorrespondenceHistoryPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Archive.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>

    {haveEditAction && haveRefrenceButton && row.status !== "7" && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">ارسال پیام</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-success btn-sm "
        onClick={() => openEditObjectPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-success">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Send.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>
    {haveRefrenceButton && row.status !== 7 && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">ارجاع مکاتبه</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm "
        onClick={() => openRefrencePage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Reply.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}

    <> </>
    {haveRefrenceButton && row.status !== 7 && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip"> تغییر وضعیت</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-warning btn-sm "
        onClick={() => openChangeStatusPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-warning">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Right.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}

    <> </>
    {haveCreateCopyAction && !haveRefrenceButton && row.isDeleted && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">ایجاد مشابه</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-success btn-sm "
        onClick={() => openCreateCopyPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-success">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>

    {haveCreateCopyAction && !haveRefrenceButton && !row.isDeleted && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">ایجاد مشابه</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-light btn-sm "
      >
        <span className="svg-icon svg-icon-md svg-icon-light">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>

    <> </>
    {haveEditAction && !haveRefrenceButton && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">ویرایش</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm "
        onClick={() => openEditObjectPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>
    {!row.isDeleted && haveDeleteAction && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">حذف</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => openDeleteObjectDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
        </span>
      </a>
    </OverlayTrigger>}


    {row.isDeleted && haveDeleteAction && !haveCreateCopyAction && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">فعالسازی</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-success btn-sm "
        onClick={() => openRefreshObjectDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-success">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Update.svg")} />
        </span>
      </a>
    </OverlayTrigger>}
    {row.isDeleted && haveDeleteAction && haveCreateCopyAction && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">فعالسازی</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-light btn-sm "
      //onClick={() => openRefreshObjectDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-light">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Update.svg")} />
        </span>
      </a>
    </OverlayTrigger>}


    <> </>
    {confirmAction && !row.isManual && !row.isPayed && !row.isExpired && !row.isCanceled && !row.acceptOperatorId
      && row.reservationTimeSetting
      && (row.expiredAt == row.reservationTimeSetting.confirmExpireDate || row.expiredAt == row.reservationTimeSetting.replaceConfirmExpireDate)
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">تایید درخواست</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-info btn-sm "
          onClick={() => openConfirmObjectPage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-info">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Double-check.svg")} />
          </span>
        </a>
      </OverlayTrigger>}

    <> </>

    {payAction && row.isConfirm && !row.isPayed && !row.isExpired && !row.isCanceled &&
      (row.price <= 0 || (row.price <= row.userCredit)) &&
      <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">تایید و پرداخت</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-success btn-sm "
          onClick={() => openFreePaymentDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-success">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")} />
          </span>
        </a>
      </OverlayTrigger>}

    {payAction && row.isConfirm && !row.isPayed && !row.isExpired && !row.isCanceled &&
      (row.price > 0 && (row.price > row.userCredit)) &&
      <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">تایید و پرداخت</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-success btn-sm "
          onClick={() => openPaymentDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-success">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/ATM.svg")} />
          </span>
        </a>
      </OverlayTrigger>}


    {cancelManagerAction && !row.isCanceled && (row.isPayed || (!row.isPayed && !row.isExpired))
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">لغو رزرو</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-warning btn-sm "
          onClick={() => openCancelDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-warning">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>}

    {cancelStudentAction && !row.isManual && !row.isCanceled && !row.isPayed && row.reservationTimeSetting && !row.reservationTimeSetting.needReplaceRequest
      && row.reservationTimeSetting.startDate && moment().isSameOrAfter(row.reservationTimeSetting.startDate)
      && row.reservationTimeSetting.endDate && moment().isSameOrBefore(row.reservationTimeSetting.endDate)
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">لغو رزرو</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-warning btn-sm "
          onClick={() => openCancelDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-warning">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>}

    {cancelStudentAction && !row.isManual && !row.isCanceled && !row.isPayed && row.reservationTimeSetting && row.reservationTimeSetting.needReplaceRequest
      && row.reservationTimeSetting.replaceStartDate && moment().isSameOrAfter(row.reservationTimeSetting.replaceStartDate)
      && row.reservationTimeSetting.replaceEndDate && moment().isSameOrBefore(row.reservationTimeSetting.replaceEndDate)
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">لغو رزرو</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-warning btn-sm "
          onClick={() => openCancelDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-warning">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>}


    {/* {replaceReservationAction && !row.isManual && !row.isCanceled && row.reservationTimeSetting
      && row.reservationTimeSetting.needReplaceRequest
      && row.reservationTimeSetting.replaceStartDate && moment().isAfter(row.reservationTimeSetting.replaceStartDate)
      && row.reservationTimeSetting.replaceEndDate && moment().isBefore(row.reservationTimeSetting.replaceEndDate)
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">جابجایی رزرو</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-info btn-sm"
          onClick={() => openReplaceReservationPage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-info">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")} />
          </span>
        </a>
      </OverlayTrigger>} */}

    {manualSwapAction && !row.isCanceled && row.userId && <OverlayTrigger
      overlay={<Tooltip id="objects-manualswap-tooltip">جابجایی</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm"
        onClick={() => openManualSwapDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Route.svg")} />
        </span>
      </a>
    </OverlayTrigger>}
    <> </>
    {showUserInfo && <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">اطلاعات دانشجو</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm "
        onClick={() => openUserPage(row.userId)}
      >
        {row.userGender === "Male" && <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/avatars/001-boy.svg")} />
        </span>}
        {row.userGender !== "Male" && <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/avatars/023-girl-13.svg")} />
        </span>}
      </a>
    </OverlayTrigger>}


    {sportCancelAction && !row.isCanceled
      && row.calendarDate && moment().isBefore(row.calendarDate)
      && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">لغو رزرو</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-warning btn-sm "
          onClick={() => openSportReservCancelDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-warning">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>}

  </>
);
